module.exports = __webpack_public_path__ + "img/fs.ac668648.png";